import { Method, send } from '../../lib/MyHttp';

/**
 * 리스트
 */
export const GetList = (component, params, success, fail) => {
    let paramsT = { ...params };
    if (!params['name']) delete paramsT['name'];

    send(component, Method.GET, '/a/placemanager', paramsT, success, fail);
};

/**
 * 엑셀 다운로드
 */
export const GetListDownload = (component, params, success, fail) => {
    let paramsT = { ...params };
    if (!params['name']) delete paramsT['name'];

    send(component, Method.GET, '/a/placemanager/download', paramsT, success, fail);
};

/**
 * 정보
 */
export const Get = (component, id, success, fail) => {
    const params = {};
    send(component, Method.GET, '/a/placemanager/' + id, params, success, fail);
};

/**
 * 등록
 */
export const Create = (component, params, success, fail) => {
    const paramsT = {
        name: params.name,
        class: params.class,
        phone: params.phone,
        status: params.status,
    };

    send(component, Method.POST, '/a/placemanager/', paramsT, success, fail);
};

/**
 * 업데이트
 */
export const Update = (component, id, params, success, fail) => {
    const paramsT = {
        name: params.name,
        class: params.class,
        phone: params.phone,
        status: params.status,
    };

    send(component, Method.PUT, '/a/placemanager/' + id, paramsT, success, fail);
};

/**
 * 삭제
 */
export const Delete = (component, id, success, fail) => {
    const params = {};
    send(component, Method.DELETE, '/a/placemanager/' + id, params, success, fail);
};
